<template>
  <PageSection>
    <PageSectionHeading
      v-if="property.listing.remarks.headline"
    >
      {{ property.listing.remarks.headline }}
    </PageSectionHeading>
    <div class="whitespace-pre-wrap">
      {{ property.listing.remarks.public_remarks }}
    </div>
  </PageSection>
</template>

<script>
import { isEmptyString } from 'mytribus-commons';

import PageSection from '../components/PageSection.vue';
import PageSectionHeading from '../components/PageSectionHeading.vue';

export default {
  name: 'PropertyDescription',

  display({ property }) {
    return !isEmptyString(property.listing.remarks.public_remarks);
  },

  components: {
    PageSection,
    PageSectionHeading,
  },

  props: {
    property: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style>
p {
  margin-top: 10px;
}
</style>
